import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconZoomOut: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 192.904 192.904" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m190.707 180.101-47.079-47.077c11.702-14.072 18.752-32.142 18.752-51.831.001-44.77-36.421-81.193-81.189-81.193-44.769 0-81.191 36.423-81.191 81.193 0 44.767 36.422 81.187 81.191 81.187 19.689 0 37.759-7.049 51.831-18.75l47.079 47.077c1.464 1.465 3.384 2.197 5.303 2.197s3.839-.732 5.303-2.197c2.93-2.929 2.93-7.677 0-10.606zm-175.707-98.908c0-36.499 29.693-66.193 66.191-66.193 36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187-36.498 0-66.191-29.691-66.191-66.187z" />
      <path d="m118.035 73.689h-73.689c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h73.689c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z" />
    </svg>
  </IconStyled>
);

IconZoomOut.defaultProps = iconDefaultProps;
IconZoomOut.displayName = 'IconZoomOut';

export default IconZoomOut;
